import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EntityService, CollectionManagerService } from '@zerops/zef/entities';
import { AppState, ApiEntityKeys } from '@zerops/zerops/app';
import { ZefWebsocketService } from '@zerops/zef/websocket';
import { IntegrationToken } from '@zerops/models/integration-token';

@Injectable({ providedIn: 'root' })
export class IntegrationTokenEntity extends EntityService<IntegrationToken> {
  constructor(
    public store: Store<AppState>,
    public collectionManager: CollectionManagerService,
    public websocketService: ZefWebsocketService
  ) {
    super(ApiEntityKeys.IntegrationToken, store, collectionManager, websocketService);
  }
}
